import axios from 'axios';
import log from '../../logger';

const baseUrl = '/data-api';

// Get all slideshows
export const getSlideshows = async () => {
  try {
    const response = await axios.get(
      `${baseUrl}/get?group=slideshows&key=all&timestamp=${Date.now()}`
    );
    return response.data;
  } catch (error) {
    log.error('Error fetching slideshows:', error);
    throw error;
  }
};

export const addImage = async (formData) => {
  try {
    const response = await axios.post(`${baseUrl}/uploadFileAndUpdateData`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    log.error('Error adding image to slideshow:', error);
    throw error;
  }
};

// Update an existing slideshow
export const updateSlideshow = async (obj) => {
  try {
    const response = await axios.post(`${baseUrl}/update`, obj);
    return response.data;
  } catch (error) {
    log.error('Error updating slideshow:', error);
    throw error;
  }
};
